<template>
	<c-dialog ref="dialog" :height="this.accountType == 3?480:550" :width="this.accountType == 3?430:450" @resolve="editHandle">
		<c-form ref="form" vertical unit-width="100%">
            <c-input type="hidden" name="id"></c-input>
            <c-form-item label="充值单号">
                <c-input name="record_number" disabled></c-input>
            </c-form-item>
            <c-form-item label="充值金额">
                <c-input name="recharge_money" disabled></c-input>
            </c-form-item>
            <c-form-item label="到账积分" v-show="this.accountType != 3">
                <c-input name="points_amount" disabled></c-input>
            </c-form-item>
            <c-form-item label="支付凭证">
                <c-file :src="voucher_url" class="image" media style="width:55px;height:55px;"></c-file>
            </c-form-item>
            <c-form-item label="审批结果" required>
                <c-radio-group name="audit_state" :options="auditStateDic" v-model="auditState"></c-radio-group>
            </c-form-item>
			<c-form-item label="审批备注" :required="auditState == 3">
                <c-input type="textarea" name="audit_remark" maxlength="500"></c-input>
			</c-form-item>
		</c-form>
	</c-dialog>
</template>

<script>
import {mapState} from 'vuex'

export default {
    name: 'rechargeAudit',

	components: {
	},
	
	data() {
		return {
            saasId:0,
            //审批结果
            auditStateDic: [
                {name: '审核通过',value: 2,color: 'blue'},
                {name: '审核拒绝',value: 3,color: 'red'},
            ],
            accountType:0,
            auditState:2,               //审批状态
            voucher_url:''
		}
	},

	computed: {
		...mapState(['systemConfig']),
	},

	methods: {
		/*********打开编辑框，初始化**********/
        open(data) {
            this.$refs.form.clear();
            data.audit_state = this.auditState;
            this.$refs.form.set(data);
            this.saasId = data.saas_id;
            this.voucher_url = data.voucher_url;
            this.accountType = data.account_type;
            var title = "充值申请审批";
            if (this.accountType == 3){
                title = "【保证金】充值申请审批";
            }else if (this.accountType == 4){
                title = "【同售积分】充值申请审批";
            }else if (this.accountType == 5){
                title = "【IMIE查询积分】充值申请审批";
            }
			//填充form表单
			this.$refs.dialog.open({
				title: title
			});
		},

		/*******创建、编辑提交处理方法********/
		editHandle (stop, next){
			stop();
			this.$refs.form.submit({
				url: '/account/recharge/audit',
				rule: {
                    audit_state: '请选择审批结果',
                    audit_remark: [{
                        type: 'empty',
                        message: '请输入审批备注',
                        skip: () => {
                            return this.auditState != 3;
                        }
                    }]
				},
				dataFormatter: data => {
                    data.client_saas_id = this.saasId;
                    return data;
				},
				success: (data, res) => {
					next();
                    this.$message({
                        message: '审批成功',  // 提示内容,
                        type: 'success'
                    });
					this.$emit('resolve');
				}
			});
		}
	}
}
</script>

<style lang="stylus" scoped>
</style>